import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  certificateTypes: [],
  certificatesSearchResult: [],
  newCertificateTypeSidebar: {
    visible: false,
    saveAction: undefined,
  },
  manageCertificateTypesSidebar: {
    visible: false,
    item: null,
  },
  roleCertificateRequirementsSidebar: {
    visible: false,
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
